import script from "./FormInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInput.vue?vue&type=script&setup=true&lang=js"

import "./FormInput.vue?vue&type=style&index=0&id=d9cc53fc&lang=css"

const __exports__ = script;

export default __exports__